import React, { useEffect } from 'react';
import { Scaffold } from 'layouts';
import * as S from './styles';
import { OrderUpdateForm } from 'components/Pages/Scheduling/UpdateForm';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { FetchOrderActions } from 'store/ducks/orders';
import { Order } from 'contracts/Orders';
import { PageProps } from 'types/global';

interface Props extends PageProps {
  order: Order;
}

export const OrderUpdatePage: React.FC<Props> = ({ order, ...props }) => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const fetchOrder = () => {
    if (!order) return dispatch(FetchOrderActions.request(id));
    dispatch(FetchOrderActions.success(order));
  };

  useEffect(() => {
    fetchOrder();

    return () => {
      dispatch(FetchOrderActions.reset());
    };
  }, []);

  return (
    <Scaffold {...props}>
      <S.PageContainer>
        <OrderUpdateForm />
      </S.PageContainer>
    </Scaffold>
  );
};
